<template>
    <Card>
        <template #header>
            <div class="pl-5 pt-4 font-medium text-[16px]">
                Privatūs užrašai
            </div>
        </template>
        <template #content>
            <div class="flex flex-col gap-4">
                <div v-for="note in notes" :key="note.id"
                     class="flex flex-col bg-gray-100 p-3 rounded gap-2"
                >
                    <div class="text-black">
                        {{ note.body }}
                    </div>

                    <div class="flex flex-row items-center text-[13px]">
                        {{ note.author }} - {{ note.created_at }}
                    </div>

                    <div v-if="is('admin')"
                         class="flex flex-row gap-1 text-[0.8rem] self-start bg-red-500 hover:bg-red-600 text-white p-[6px] rounded items-center justify-center cursor-pointer"
                         @click.stop.prevent="deleteNote(note.id)"
                    >
                        <i class="pi pi-trash !text-[0.8rem]"></i>
                        Ištrinti
                    </div>

                </div>

                <div class="flex flex-col gap-2">
                    <Textarea placeholder="Tekstas" v-model="noteBody" class="w-full" size="small" autoResize />

                    <Button label="Išsaugoti" size="small" @click="saveNote" :loading="noteSaving" class="self-start" />
                </div>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    // System imports
    import { ref, onMounted, computed, watch } from 'vue';
    import { apiRequest } from '@/services/axios.ts'

    // PrimeVue components imports
    import { useConfirm } from 'primevue/useconfirm'
    import Textarea from 'primevue/textarea';
    import Card from 'primevue/card'
    import Button from 'primevue/button';
    import { is } from '@/extensions/permissions.ts'

    // Refs and variables
    const confirm = useConfirm();
    const notes = ref();
    const noteBody = ref();
    const noteSaving = ref();

    // Emits
    const emit = defineEmits<{
        (e: 'draft-changed', value: boolean): void
    }>();

    // Props
    let props = defineProps<{
        contact: any
    }>();

    const hasDraft = computed(() => {
        const body = typeof noteBody.value === 'string' ? noteBody.value.trim() : '';

        return body !== '';
    });

    // Hooks
    onMounted(() => {
        loadNotes();
    });

    watch(
        hasDraft,
        (value) => {
            emit('draft-changed', value);
        },
        { immediate: true }
    );

    // Methods
    async function saveNote() {
        await apiRequest(
            'post',
            '/contacts/' + props.contact.id + '/private-notes',
            {
                body: noteBody.value
            }
        );

        noteBody.value = '';

        await loadNotes()
    }

    async function loadNotes() {
        const response = await apiRequest(
            'get',
            '/contacts/' + props.contact.id + '/private-notes'
        );

        notes.value = response.data.data.notes;
    }

    async function deleteNote(noteId: number) {
        confirm.require({
            message: 'Ar tikrai norite ištrinti šį įrašą?',
            header: 'Patvirtinimas',
            icon: 'pi pi-exclamation-triangle',
            rejectProps: {
                label: 'Ne',
                severity: 'secondary',
                outlined: true,
            },
            acceptProps: {
                label: 'Taip'
            },
            accept: async () => {
                await apiRequest(
                    'delete',
                    '/contacts/' + props.contact.id + '/private-notes/' + noteId
                );

                await loadNotes();
            }
        });
    }
</script>
